import { render, staticRenderFns } from "./visitOwnerRepair.vue?vue&type=template&id=6b2c5f5e"
import script from "./visitOwnerRepair.vue?vue&type=script&lang=js"
export * from "./visitOwnerRepair.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports